module.exports = __webpack_public_path__ + "03_very_short_yellow.dee19f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_very_short_yellow.png
// module id = 7twA
// module chunks = 0